import type { FaireProductEntity } from "../../entity_types/product";

export const p_mfh9nxeyyd: FaireProductEntity = {
  token: "p_mfh9nxeyyd",
  type: "product",
  name: "Swedish Dishcloth - Mussels - Blue",
  brandToken: "b_frbt34h3nt",
  brandName: "Jangneus",
  imageUrl:
    "https://cdn.faire.com/fastly/19310f035fb67db28efa797a94f51c1e220e40889993b625bfbcad9bb21cd6f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e90a6a4d51fba9991ea1623266d4932d1028ca70369f15aee2d052ff27c1ca8.jpeg",
    "https://cdn.faire.com/fastly/2c752557b994fe415c4f221e77a16fc9853875005d4c80cd24c03f85e6109402.jpeg",
    "https://cdn.faire.com/fastly/6b969223e017732e634665a08ff5498a774721c493dd4d3c99a2a2ac6b4eb304.jpeg",
  ],
  priceDollars: 3,
  description:
    'These sponge cloths are guaranteed to bring fresh Scandinavian style into your kitchen. Used in Swedish kitchens since the 1950s, these tried and trusted dishcloths are made of all natural and renewable materials. Highly durable, they are great for washing up, general cleaning and mopping up spills. Matching kitchen towels are available to keep your kitchen looking smart and coordinated.  Highly absorbent, they can absorb 15 times its own weight in water. Machine washable. Designed by Jangneus in Sweden. Size: W6.75"x L8". 100% biodegradable. Made of 70% cellulose and 30% cotton',
  tags: [],
  msrpDollars: 6.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:15.471Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
